console.log("Quiz.js loaded successfully!");

// ----------------------------------
// Główne obiekty i mapy
// ----------------------------------
const quizAnswers = {};

// Mapa synonimów, aby obsłużyć różne odmiany nut
let synonymsMap = {};
let availableNotes = [];

// Moduł ładujący dane z quiz.json
const QuizDataLoader = {
  data: null,
  loadData: function(callback) {
    if (window.__quizProductsFetched) {
     
      return;
    }
    window.__quizProductsFetched = true;

    const token = '3ccfa2a8ad1833bbf9fddb86cff6eb5d';
    const endpoint = 'https://7c4d54.myshopify.com/api/2023-10/graphql.json';
    const allProducts = [];

    async function fetchProducts(cursor = null) {
      const query = `
        query GetPerfumeProducts($cursor: String) {
          collection(handle: "perfume") {
            products(first: 100, after: $cursor) {
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  handle
                  title

                  feminine: metafield(namespace: "custom", key: "feminine") {
                    value
                  }
                  masculine: metafield(namespace: "custom", key: "masculine") {
                    value
                  }
                  unisex: metafield(namespace: "custom", key: "unisex") {
                    value
                  }

                   fragranceNotesMeta: metafield(namespace: "custom", key: "fragrance_notes") {
              value
              type
            }
                }
              }
            }
          }
        }
      `;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
          'Accept-Language': Shopify?.locale || 'en' 
        },
        body: JSON.stringify({
          query,
          variables: { cursor }
        })
      });

      const json = await response.json();
      const edges = json?.data?.collection?.products?.edges || [];
      const pageInfo = json?.data?.collection?.products?.pageInfo;

      

      edges.forEach(({ node }, index) => {
      
        
        const feminine = node.feminine?.value === 'true';
        const masculine = node.masculine?.value === 'true';
        const unisex = node.unisex?.value === 'true';

    
let fragranceNotes = [];

try {
  const raw = node.fragranceNotesMeta?.value;
  if (raw) {
    if (raw.trim().startsWith("[")) {
      // Jeśli wygląda na listę JSON
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        fragranceNotes = parsed.map(n => n.toLowerCase().trim()).filter(Boolean);
      }
    } else {
      // Jeśli zwykły tekst (np. multi_line_text_field)
      fragranceNotes = raw.split("\n").map(n => n.toLowerCase().trim()).filter(Boolean);
    }
  }
} catch (err) {
  console.warn(`❌ Błąd parsowania fragrance_notes dla ${node.title}:`, err);
}


      

        allProducts.push({
          handle: node.handle,
          title: node.title,
          feminine,
          masculine,
          unisex,
          fragranceNotes
        });

        console.groupEnd();
      });

      if (pageInfo?.hasNextPage) {
        
        await fetchProducts(pageInfo.endCursor);
      } else {
      
      }
    }

    fetchProducts().then(() => {
      this.data = allProducts;
    
      if (typeof callback === 'function') callback(this.data);
    }).catch(err => {
    
    });
  }
};





function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Zarządzanie odpowiedziami
const QuizAnswersManager = {
  answers: {},
  setAnswer: function(questionId, value, element) {
  if (questionId === "question-1") {
    // Ustawiamy jednokrotny wybór (tylko jedna opcja może być aktywna)
    this.answers[questionId] = [value];

    // Usuwamy klasę "active" z innych opcji
    document.querySelectorAll(`#${questionId} .quiz-option`).forEach(btn => btn.classList.remove("active"));

    // Dodajemy klasę "active" do wybranego przycisku
    element.classList.add("active");

   
  } else {
    // Standardowa logika toggle dla innych pytań
    if (!this.answers[questionId]) {
      this.answers[questionId] = [];
    }

    if (this.answers[questionId].includes(value)) {
      this.answers[questionId] = this.answers[questionId].filter(item => item !== value);
      element.classList.remove("active");
    } else {
      this.answers[questionId].push(value);
      element.classList.add("active");
    }
  }


},


  getAnswers: function(questionId) {
    return this.answers[questionId] || [];
  },

  resetAnswers: function(questionId) {
    if (questionId === "question-1") {
      this.answers[questionId] = "";
      document.querySelectorAll(`#${questionId} .quiz-option`).forEach(btn => btn.classList.remove("active"));
    } else {
      this.answers[questionId] = [];
      document.querySelectorAll(`#${questionId} .quiz-option.active`).forEach(btn => btn.classList.remove("active"));
    }

   
    // Jeśli resetujemy nuty, przywracamy domyślną listę perfum
    if (questionId === "question-2") {
      generateFragranceNotesByGender();
    }
  }
};


// Nawigacja Dalej / Wstecz
const QuizNavigator = {
  init: function() {
    document.querySelectorAll('.quiz-next').forEach(button => {
      button.addEventListener('click', event => {
        this.goToNextQuestion(event.target.closest('.question'));
      });
    });
    document.querySelectorAll('.quiz-back').forEach(button => {
      button.addEventListener('click', event => {
        this.goToPreviousQuestion(event.target.closest('.question'));
      });
    });
    // Po kliknięciu "Zobacz Wyniki" -> logika filtrująca
   const resultsBtn = document.getElementById('show-results');
if (resultsBtn) {
  resultsBtn.addEventListener('click', () => {
    QuizFilter.filterResults();
  });
}
  
   // Reset nut zapachowych – przycisk "Clear All"
document.getElementById('reset-notes').addEventListener('click', () => {
  // Resetujemy odpowiedzi dla pytania 2 (nuty)
  QuizAnswersManager.resetAnswers("question-2");
  
  // Jeśli po resecie nie ma zaznaczonych nut, czyścimy wyniki i usuwamy nagłówek
  if (QuizAnswersManager.getAnswers("question-2").length === 0) {
    // Czyszczenie kontenera wyników (produkty)
    const productContainer = document.querySelector("#quiz-product-container");
    if (productContainer) {
      productContainer.innerHTML = "";
    }
    // Usuwamy nagłówek wyników, aby napis "Your fragrance" lub "Your fragrances" zniknął
    const headerWrapper = document.getElementById("quiz-results-wrapper");
    if (headerWrapper) {
      headerWrapper.remove();
    }
  } else {
    // Jeśli jakieś nuty są jeszcze zaznaczone, przefiltruj wyniki
    QuizFilter.filterResults();
  }
});


  },
  goToNextQuestion: function(currentQuestion) {
    let next = currentQuestion.nextElementSibling;
    while (next && !next.classList.contains('question')) {
      next = next.nextElementSibling;
    }
    if (next) {
      currentQuestion.classList.add('hidden');
      next.classList.remove('hidden');

      // Specjalna logika: jeśli przechodzimy z question-1 -> question-2,
      // generujemy listę nut na podstawie wybranego gender.
      if (currentQuestion.id === "question-1" && next.id === "question-2") {
        generateFragranceNotesByGender();
      }
    }
  },
  goToPreviousQuestion: function(currentQuestion) {
    let previous = currentQuestion.previousElementSibling;
    while (previous && !previous.classList.contains('question')) {
      previous = previous.previousElementSibling;
    }
    if (previous) {
      currentQuestion.classList.add('hidden');
      previous.classList.remove('hidden');
    }
  }
};



// Moduł filtrujący i punktujący
const QuizFilter = {
  filterResults: function() {
    const data = QuizDataLoader.data;
    if (!data) {
      console.error('❌ Dane quizu nie są załadowane.');
      return;
    }

    // Pobierz wybrane płcie i nuty
    const selectedGenders = QuizAnswersManager.getAnswers("question-1");
    const selectedNotes = QuizAnswersManager.getAnswers("question-2");

    

    if (selectedGenders.length === 0) {
      console.error("❌ Nie wybrano płci (pytanie 1)");
      return;
    }

    // Jeśli nie wybrano żadnej nuty, czyścimy wyniki i usuwamy nagłówek
    if (selectedNotes.length === 0) {
      const productContainer = document.querySelector("#quiz-product-container");
      if (productContainer) {
        productContainer.innerHTML = "";
      }
      const headerWrapper = document.getElementById("quiz-results-wrapper");
      if (headerWrapper) {
        headerWrapper.remove();
      }
     
      return;
    }

    // Filtrujemy produkty wg. wybranej płci
    let filteredData = data.filter(item => {
  return (
    (item.feminine && selectedGenders.includes('feminine')) ||
    (item.masculine && selectedGenders.includes('masculine')) ||
    (item.unisex && selectedGenders.includes('unisex'))
  );
});


    // Obliczamy punktację perfum względem zaznaczonych nut
    const scoredData = filteredData.map(product => {
      const fragranceNotes = product.fragranceNotes || [];
      let matches = selectedNotes.reduce((count, note) => count + (fragranceNotes.includes(note) ? 1 : 0), 0);
      const matchPercentage = fragranceNotes.length > 0 ? (matches / fragranceNotes.length) : 0;
      const scaledMatchPercentage = matchPercentage * 5;
      const finalScore = matches + scaledMatchPercentage;

      return {
        ...product,
        score: matches,
        matchPercentage,
        scaledMatchPercentage,
        finalScore
      };
    });

    // Sortujemy produkty po finalScore malejąco
    const sortedResults = scoredData.sort((a, b) => b.finalScore - a.finalScore);
    

    // Filtrujemy tylko te produkty, które zawierają WSZYSTKIE wybrane nuty
    const matchedPerfumes = sortedResults.filter(product => {
  // Przekształcamy nuty produktu do postaci kanonicznej
  const canonicalNotes = product.fragranceNotes.map(getCanonicalNote);
  // Dla każdej wybranej nuty sprawdzamy, czy znajduje się ona w przekształconej liście
  return selectedNotes.every(note => canonicalNotes.includes(note));
});

   

    // Aktualizujemy licznik perfum
    updatePerfumeCount(matchedPerfumes.length);

    // Pobieramy identyfikatory produktów, które mają zostać wyświetlone
    const matchedHandles = matchedPerfumes.slice(0, matchedPerfumes.length).map(p => p.handle);
   

    // Jeśli brak dopasowań, wyświetlamy komunikat
    if (matchedHandles.length === 0) {
      document.querySelector("#quiz-product-container").innerHTML =
        "<p>❌ Brak dopasowanych perfum. Spróbuj wybrać inne nuty!</p>";
      return;
    }

    // Aktualizujemy sekcję z produktami
    updateQuizProductSection(matchedHandles);
  }
};





function updateQuizProductSection(handles) {
    const productContainer = document.querySelector("#quiz-product-container");

    if (!productContainer) {
        console.error("❌ Błąd: Nie znaleziono kontenera #quiz-product-container!");
        return;
    }

    // Sprawdzamy, czy istnieje już wrapper <div class="quiz-navigation">
    let headerWrapper = document.getElementById("quiz-results-wrapper");

    if (!headerWrapper) {
        // Tworzymy nowy div, który będzie zawierał nagłówek
        headerWrapper = document.createElement("div");
        headerWrapper.id = "quiz-results-wrapper";
        headerWrapper.className = "quiz-navigation";

        // Tworzymy nagłówek <h2>
        const header = document.createElement("h2");
        header.id = "quiz-results-header";
        header.className = "heading h2";

        // Dodajemy nagłówek do wrappera
        headerWrapper.appendChild(header);

        // Wstawiamy cały wrapper PRZED `#quiz-product-container`
        productContainer.parentNode.insertBefore(headerWrapper, productContainer);
    }

    // Aktualizacja treści nagłówka
    const header = document.getElementById("quiz-results-header");
    header.textContent = handles.length === 1 ? window.yourMatchTranslation : window.yourMatchesTranslation;
    header.style.marginBottom = "20px"; // Dodatkowy odstęp

  
    if (handles.length === 0) {
        productContainer.innerHTML = "<p>❌ Brak dopasowanych perfum. Spróbuj wybrać inne nuty!</p>";
        return;
    }

    // Czyścimy kontener produktów i dodajemy loader
    productContainer.innerHTML = "<p>Ładowanie produktów...</p>";

    // Pobieramy i renderujemy produkty
    const fetchPromises = handles.map(handle => {
        return fetch(`/products/${handle}?section_id=quiz-product`)
            .then(response => {
                if (!response.ok) throw new Error(`Błąd pobierania produktu: ${handle}`);
                return response.text();
            })
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newContent = doc.querySelector("#quiz-product-container")?.innerHTML;

                if (!newContent) {
                    throw new Error(`Błąd: Brak zawartości dla ${handle}`);
                }

                return newContent;
            })
            .catch(error => {
                console.error(error);
                return `<p>Błąd ładowania produktu: ${handle}</p>`;
            });
    });

    // Po załadowaniu produktów aktualizujemy sekcję
    Promise.all(fetchPromises).then(productsHTML => {
        productContainer.innerHTML = productsHTML.join(""); // Wypełniamy kontener produktami
       
    });
}



/* -------------------- Funkcja generująca listę nut wg wybranej płci -------------------- */
/**
 * Funkcja pomocnicza – zamienia daną nutę zapachową 
 * na nazwę kanoniczną (zamiast synonimu).
 */
function getCanonicalNote(note) {
  const noteLower = note.toLowerCase();

  // Przeszukujemy synonymsMap, np.:
  //  "cedar": [ "atlas cedar", "virginia cedar", ... ]
  for (const [canonical, synonyms] of Object.entries(synonymsMap)) {
    // Sprawdź, czy note jest dokładnie główną nazwą
    if (canonical.toLowerCase() === noteLower) {
      return canonical; 
    }
    // Albo czy jest w tablicy synonimów
    const lowerSynonyms = synonyms.map(s => s.toLowerCase());
    if (lowerSynonyms.includes(noteLower)) {
      // Zwracamy klucz główny, np. "cedar"
      return canonical;
    }
  }

  // Jeżeli nie znaleziono w synonymsMap -> zwracamy oryginał
  return note;
}


/**
 * Funkcja generująca listę nut zapachowych według wybranej płci.
 * Zamiast wielu wariantów z synonymsMap,
 * do listy trafia wyłącznie nazwa kanoniczna (np. "cedar").
 */
// Aktualizowanie liczby dostępnych perfum
function updatePerfumeCount(count) {
    const countElement = document.getElementById("perfume-count");
    if (countElement) {
        countElement.textContent = `Number of matched perfumes: ${count}`;
    } else {
        console.warn("⚠️ Element #perfume-count nie istnieje w DOM!");
    }
}

// Wygenerowanie listy nut zapachowych według wybranej płci
function generateFragranceNotesByGender() {
  const selectedGenders = QuizAnswersManager.getAnswers("question-1");
  if (!selectedGenders.length) {
    console.error("Brak wybranej płci -> nie można generować nut zapachowych");
    return;
  }
  
  const data = QuizDataLoader.data;
  if (!data) {
    console.error("Brak danych quizu (QuizDataLoader.data)!");
    return;
  }
  
  // Filtrujemy produkty wg. płci
  let matchingPerfumes = data.filter(item => {
  return (
    (item.feminine && selectedGenders.includes('feminine')) ||
    (item.masculine && selectedGenders.includes('masculine')) ||
    (item.unisex && selectedGenders.includes('unisex'))
  );
});

  
  // Jeśli są już zaznaczone nuty, dodatkowo filtrujemy produkty,
  // aby zawierały WSZYSTKIE wybrane nuty.
  const selectedNotes = QuizAnswersManager.getAnswers("question-2");
 if (selectedNotes.length > 0) {
  matchingPerfumes = matchingPerfumes.filter(product => {
    // Przekształcamy nuty produktu do postaci kanonicznej
    const canonicalNotes = product.fragranceNotes.map(getCanonicalNote);
    // Sprawdzamy, czy dla każdej wybranej nuty produkt zawiera co najmniej jedną odpowiadającą nutę z mapowania
    return selectedNotes.every(note => canonicalNotes.includes(note));
  });
}

  
  // Aktualizacja liczby pasujących perfum
  const perfumeCountContainer = document.getElementById("perfume-count");
  if (perfumeCountContainer) {
    perfumeCountContainer.textContent = `Number of matched perfumes: ${matchingPerfumes.length}`;
  }
  

  
  // Zbieramy wszystkie unikalne nuty dostępne w przefiltrowanych perfumach
  const allNotes = new Set();
  matchingPerfumes.forEach(item => {
    if (item.fragranceNotes) {
      item.fragranceNotes.forEach(note => {
        const canonicalNote = getCanonicalNote(note);
        allNotes.add(canonicalNote);
      });
    }
  });
  
  // Zapisujemy posortowaną listę nut do globalnej zmiennej
  availableNotes = Array.from(allNotes).sort();
  
  // Po przeliczeniu dostępnych nut wywołujemy funkcję renderującą przyciski
  renderFragranceNotes();
}







// Wyszukiwanie w polu #search-notes
function filterFragranceNotes() {
  renderFragranceNotes();
}






function updateGenderDesign() {
  document.querySelectorAll('#gender-options .quiz-option').forEach(button => {
    const facetWrapper = button.querySelector('.removable-facet');
    if (!facetWrapper) {
      // Jeśli wrapper nie istnieje, wychodzimy z iteracji dla tego przycisku
      return;
    }
    const textSpan = facetWrapper.querySelector('.quiz-note-text');
    
    if (button.classList.contains('active')) {
      if (!facetWrapper.querySelector('.quiz-note-icon')) {
        const iconWrapper = document.createElement("span");
        iconWrapper.classList.add("quiz-note-icon");
        iconWrapper.innerHTML = `
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        `;
        facetWrapper.insertBefore(iconWrapper, textSpan);
      }
    } else {
      const icon = facetWrapper.querySelector('.quiz-note-icon');
      if (icon) {
        icon.remove();
      }
    }
  });
}

function updateSelectedNotesDisplay() {
  const selectedNotes = QuizAnswersManager.getAnswers("question-2");
  const container = document.getElementById("selected-notes");
  container.innerHTML = "";
  
  // Jeśli są zaznaczone nuty, dodaj przycisk "Clear All" jako pierwszy element
  if (selectedNotes.length > 0) {
    const clearAllBtn = document.createElement("button");
    clearAllBtn.classList.add("quiz-option", "quiz-option-2");
    clearAllBtn.setAttribute("data-value", "clear-all");
    
    const facetWrapper = document.createElement("div");
    facetWrapper.classList.add("removable-facet", "removable-facet-addon");
    
    const iconWrapper = document.createElement("span");
    iconWrapper.classList.add("quiz-note-icon");
    iconWrapper.innerHTML = `<svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
                                <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="2"></path>
                              </svg>`;
    facetWrapper.appendChild(iconWrapper);
    
    const textSpan = document.createElement("span");
    textSpan.classList.add("quiz-note-text");
    // Używamy tłumaczenia z Liquid
    textSpan.textContent = window.clearAllTranslation;
    facetWrapper.appendChild(textSpan);
    
    clearAllBtn.appendChild(facetWrapper);
    
    clearAllBtn.addEventListener("click", () => {
      QuizAnswersManager.resetAnswers("question-2");
      updateSelectedNotesDisplay();
      renderFragranceNotes();
      QuizFilter.filterResults();
    });
    
    // Dodaj przycisk "Clear All" jako pierwszy element
    container.prepend(clearAllBtn);
  }
  
  // Następnie dodaj pozostałe zaznaczone nuty
  selectedNotes.forEach(note => {
    const btn = document.createElement("button");
    btn.classList.add("quiz-option", "quiz-option-2", "active");
    btn.setAttribute("data-value", note);
    
    const facetWrapper = document.createElement("div");
    facetWrapper.classList.add("removable-facet", "removable-facet-addon");
    
    // Dodaj ikonę X
    const iconWrapper = document.createElement("span");
    iconWrapper.classList.add("quiz-note-icon");
    iconWrapper.innerHTML = `<svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
                                <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="2"></path>
                              </svg>`;
    facetWrapper.appendChild(iconWrapper);
    
    const textSpan = document.createElement("span");
    textSpan.classList.add("quiz-note-text");
    textSpan.textContent = capitalizeFirstLetter(note);

    facetWrapper.appendChild(textSpan);
    
    btn.appendChild(facetWrapper);
    
    btn.addEventListener("click", () => {
      QuizAnswersManager.setAnswer("question-2", note, btn);
      generateFragranceNotesByGender();
  updateSelectedNotesDisplay();
  renderFragranceNotes();
  QuizFilter.filterResults();
    });
    
    container.appendChild(btn);
  });
}







function renderFragranceNotes() {
  const searchValue = document.getElementById("search-notes").value.toLowerCase().trim();
  const container = document.getElementById("notes-container");
  container.innerHTML = "";
  
  // Jeśli pole wyszukiwania jest puste, nie wyświetlamy żadnych nut
  if (searchValue.length === 0) {
    const separatorContainer = document.querySelector('.separator-container');
    separatorContainer.style.display = "none"; // Ukrywamy separator, gdy nic nie jest wyświetlane
    return;
  }
  
  // Pobieramy zaznaczone nuty, aby nie wyświetlać ich wśród niezaznaczonych
  const selectedNotes = new Set(QuizAnswersManager.getAnswers("question-2"));
  let notesToDisplay = [];
  
  availableNotes.forEach(note => {
    if (!selectedNotes.has(note)) {
      if ((searchValue.length === 1 && note.toLowerCase().startsWith(searchValue)) ||
          (searchValue.length >= 2 && note.toLowerCase().includes(searchValue))) {
        notesToDisplay.push(note);
      }
    }
  });
  
  notesToDisplay.sort().forEach(note => {
    const btn = document.createElement("button");
    btn.classList.add("quiz-option", "quiz-option-2");
    btn.setAttribute("data-value", note);
    
    const facetWrapper = document.createElement("div");
    facetWrapper.classList.add("removable-facet", "removable-facet-addon");
    
    const textSpan = document.createElement("span");
    textSpan.classList.add("quiz-note-text");
    textSpan.textContent = capitalizeFirstLetter(note);

    facetWrapper.appendChild(textSpan);
    
    btn.appendChild(facetWrapper);
    
    btn.addEventListener("click", (event) => {
      QuizAnswersManager.setAnswer("question-2", note, event.currentTarget);
      generateFragranceNotesByGender();
      renderFragranceNotes();
      QuizFilter.filterResults();
    });
    container.appendChild(btn);
  });
  
  // Aktualizujemy widok zaznaczonych nut
  updateSelectedNotesDisplay();
  
  // Warunkowo ustawiamy separator:
  // Separator pokazujemy TYLKO, gdy w wynikach wyszukiwania są dostępne niezaznaczone nuty.
  const separatorContainer = document.querySelector('.separator-container');
  if (notesToDisplay.length > 0) {
    separatorContainer.style.display = "block";
  } else {
    separatorContainer.style.display = "none";
  }
}






/* -------------------- Inicjalizacja DOM -------------------- */

document.addEventListener('DOMContentLoaded', () => {
  console.log("✅ Quiz.js loaded!");



  // Ładujemy dane przez QuizDataLoader.loadData
  QuizDataLoader.loadData((data) => {
    // Inicjalizacja quizu po poprawnym wczytaniu danych
    QuizNavigator.init();
  });

  // Debugowanie wyboru płci
document.querySelectorAll('#question-1 .quiz-option').forEach(button => {
  button.addEventListener('click', event => {
    const btn = event.currentTarget;
    const selectedValue = btn.getAttribute('data-value');

    const spinner = btn.querySelector('.spinner');
    const label = btn.querySelector('.quiz-note-text');

    console.log("🟡 Spinner kliknięty:", selectedValue);
    console.log("🔍 spinner:", spinner, "| label:", label);
    console.log("✅ QuizDataLoader.data załadowane?", !!QuizDataLoader.data);

    if (!QuizDataLoader.data) {
      if (spinner && label) {
        spinner.style.display = 'inline-block';
        label.style.display = 'none';
      } else {
        console.warn("⚠️ Nie znaleziono spinnera lub labela w przycisku!");
      }

      const waitForData = setInterval(() => {
        if (QuizDataLoader.data) {
          clearInterval(waitForData);
          if (spinner && label) {
            spinner.style.display = 'none';
            label.style.display = 'inline';
          }

          QuizAnswersManager.setAnswer("question-1", selectedValue, btn);
          updateGenderDesign();
          QuizAnswersManager.resetAnswers("question-2");

          const productContainer = document.querySelector("#quiz-product-container");
          if (productContainer) productContainer.innerHTML = "";

          const headerWrapper = document.getElementById("quiz-results-wrapper");
          if (headerWrapper) headerWrapper.remove();

          const question2 = document.getElementById("question-2");
          if (question2) question2.classList.remove("hidden");
        }
      }, 100);
    } else {
      QuizAnswersManager.setAnswer("question-1", selectedValue, btn);
      updateGenderDesign();
      QuizAnswersManager.resetAnswers("question-2");

      const productContainer = document.querySelector("#quiz-product-container");
      if (productContainer) productContainer.innerHTML = "";

      const headerWrapper = document.getElementById("quiz-results-wrapper");
      if (headerWrapper) headerWrapper.remove();

      const question2 = document.getElementById("question-2");
      if (question2) question2.classList.remove("hidden");
    }
  });
});




  // Debugowanie przed generowaniem nut zapachowych
  const resultsBtnDOM = document.getElementById('show-results');
  if (resultsBtnDOM) {
    resultsBtnDOM.addEventListener('click', () => {
    
      if (QuizAnswersManager.getAnswers("question-1").length === 0) {
        console.error("❌ Brak wybranej płci! Użytkownik musi coś wybrać.");
      }
      QuizFilter.filterResults();
    });
  }
});


